import * as React from "react";
import { Navbar, Nav, NavItem, NavDropdown, MenuItem } from "react-bootstrap"
import { LinkContainer } from "react-router-bootstrap"

import { RouteButton } from "../Component/RouteButton"
import { showLoginPopup, logout } from "../Login/Login"
import { showSetPasswordPopup } from "../Login/SetPassword";
import { IRouteProps } from "../domene"

import { appContext } from "./appContext"

export class Meny extends React.Component<IRouteProps, {}> {
    constructor(props: IRouteProps) {
        super(props);
    }
    render() {
        const loggedIn = !!appContext.innloggetBruker;
        const erEksternBruker = appContext.harRelasjon(Gf.Dom.Type.AktørrelasjonType.EksternBruker);

        const kanSePoliser = loggedIn && !erEksternBruker;
        const kanSeAktører = loggedIn && !erEksternBruker;
        const kanSeFakturaer = loggedIn && !erEksternBruker;
        const kanSeRapporter = appContext.erTffAnsatt && !erEksternBruker;
        return <div className="hoved"><Navbar>
                   <Navbar.Header>
                       <Navbar.Brand>
                           <RouteButton to="/">Grenseforsikring{appContext.testServer ? ` ${appContext.plassering}` : null}</RouteButton>
                       </Navbar.Brand>
                       <Navbar.Toggle/>
                   </Navbar.Header>
                   <Navbar.Collapse>
                       <Nav pullRight>
                           {kanSePoliser ? <LinkContainer to={appContext.addContextPathAndFixUrl("/Polise/")}><NavItem>Poliser</NavItem></LinkContainer> : null}
                           {kanSeAktører ? <LinkContainer to={appContext.addContextPathAndFixUrl("/Aktor/")}><NavItem>Aktører</NavItem></LinkContainer> : null}
                           {kanSeFakturaer ? <LinkContainer to={appContext.addContextPathAndFixUrl("/Faktura/")}><NavItem>Fakturaer</NavItem></LinkContainer> : null}
                           {kanSeRapporter ? <LinkContainer to={appContext.addContextPathAndFixUrl("/Rapport/")}><NavItem>Rapporter</NavItem></LinkContainer> : null}
                           {loggedIn
                               ? <NavDropdown title={appContext.effektivAktørNavn || appContext.effektivAktørEpost} id="basic-nav-dropdown">
                                     {appContext.visSomAktorId ? null : <MenuItem onClick={() => showSetPasswordPopup({
                                             ClickedEmailLink: false,
                                             Password: "",
                                             RepeatPassword: "",
                                             Code: "",
                                             Username: appContext.innloggetBruker || "" as string,
                                             SetName: false,
                                             Name: ""
                                     }) }>Endre passord</MenuItem>}
                                     <MenuItem eventKey={4.2} onClick={() => logout({
                                         Username: appContext.innloggetBruker || "" as string
                                     }, undefined) }>{appContext.visSomAktorId ? "Avslutt vis som" : "Logg ut"}</MenuItem>
                                 </NavDropdown>
                               : <NavItem onClick={() => showLoginPopup() } href="#">Logg inn</NavItem>}
                       </Nav>
                   </Navbar.Collapse>
               </Navbar>
        {this.props.children}
        </div>;
    }
}



// WEBPACK FOOTER //
// ./Scripts/React/App/Meny.tsx